import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';


import { HelperService, DataService } from 'app/services';

import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie';
import { appointmentRequestTrialStatus } from 'app/constants/csv/constants';

@Component({
  selector: 'app-appointment-request-trial',
  templateUrl: './appointment-request-trial.component.html',
  styleUrls: ['./appointment-request-trial.component.scss'],
})
export class AppointmentRequestTrialComponent implements OnInit, OnDestroy {
  @ViewChild('intercomBtn', { static: true }) intercomBtn: ElementRef;
  @Input() trial: any;
  selected: boolean = false;
  isIntercomSetupDone: boolean = false;
  broadcastChannel: any;
  appointmentRequestTrialStatus = appointmentRequestTrialStatus;
  constructor(
    public helperService: HelperService,
    private dataService: DataService,
    private cookieService: CookieService,
    private router: Router
  ) {}

   ngOnInit() {
    if (!this.helperService.isAppleDevice()) {
      this.broadcastChannel = new BroadcastChannel('intercom-close');
    }
    //Open Intercom
    this.setDataListeners();
    this.makeTokenData();
  }

  setDataListeners() {
    if (this.broadcastChannel) {
      this.broadcastChannel.onmessage = () => {
        if (this.selected) (<any>window).Intercom('hide');
      };
    }
  }

  makeTokenData() {
    if (this.isIntercomSetupDone) return;
    this.isIntercomSetupDone = true;

    const token = this.cookieService.getObject('alpat');

    if (token) {
      const data = this.helperService.jwtDecode(token);
      const companyData: any = {};

      if (this.dataService.company.externalId) {
        if (this.dataService.company) {
          companyData.id = this.dataService.company.externalId;
          companyData.name = this.dataService.company.name;
          companyData.website = this.dataService.company.website;
          companyData.custom_attributes = {
            primary_contact: this.dataService.company.phone,
          };
        }
      }

      if (data) {
        (<any>window).Intercom('boot', {
          app_id: environment.APP_ID,
          name: data.fullName,
          email: data.userName,
          phone: data.otherUserName,
          permission: data.role,
          customer: data.name,
          company_email: data.email,
          url: this.router.url,
          alignment: 'right',
          custom_launcher_selector: '#intercom-chat',
          horizontal_padding: 100,
          vertical_padding: 0,
          hide_default_launcher: true,
          company: companyData,
        });

        const defaultMessage = 'Hey! I would like to get access to the full version of appointment request portal.';

        (<any>window).Intercom('onShow', () => {
          (<any>window).Intercom('showNewMessage', defaultMessage);
        });

        (<any>window).Intercom('onHide', () => {
          this.hideIntercom();
          (<any>window).Intercom('hide');
          this.selected = false;

          if (this.broadcastChannel) {
            this.broadcastChannel.postMessage('close');
          }
        });

        return data;
      }
    }
    return {};
  }

  hideIntercom() {
    this.selected = false;
    if (this.intercomBtn && this.intercomBtn.nativeElement && this.intercomBtn.nativeElement.classList) {
      this.intercomBtn.nativeElement && this.intercomBtn.nativeElement.classList && this.intercomBtn.nativeElement.classList.remove('highlight');
    }
  }

  toggleHighlight() {
    this.selected = !this.selected;
  }

  ngOnDestroy() {
    (<any>window).Intercom('shutdown');
  }
}
